<template>
  <div class="license-image-card-item">
    <p class="license-image-card-item_title">
      {{ title }}
    </p>
    <p>{{ textContent }}</p>
  </div>
</template>
<script>
export default {
  name: "LicenseImageCardItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    textContent: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.license-image-card-item {
  p {
    @include auto_margin_top(10px);
    font-size: 1rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: 1px;
    color: var(--gray-900);
    &.license-image-card-item_title {
      @include auto_margin_top(0px);
      color: var(--gray-700);
    }
  }
}
</style>